import type { Blueprint } from '../../base/blueprints/Blueprint';
import { instanceOfBlueprint } from '../../base/blueprints/Blueprint';
import type { NeverChoice } from '../enums/NeverChoice';
import type { WhenChoice } from '../enums/WhenChoice';

export interface CustomErrorBlueprint extends Blueprint
{
    customError: NeverChoice | WhenChoice;
    customErrorWhen: string;
    customErrorMessage: Record<string, string>;
}

export const instanceOfCustomErrorBlueprint = (object: any): object is CustomErrorBlueprint =>
{
    return instanceOfBlueprint(object) && 'customError' in object;
};
